import React from 'react'
import { Table, Message } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import { getPullOff, onCommodity } from '../../../api/businessCommodity'
import { toNormalTime, fixPhotoUrl } from '../../../util/index'

export default class extends React.Component {
  state = {
    list: [],
  }

  componentDidMount() {
    this.getPullOffList()
  }

  getPullOffList = async () => {
    const { data, status, detail } = await getPullOff()
    if (status == 1) {
      this.setState({ list: data })
    } else {
      Message.error(detail)
    }
  }

  pushUp = async (index) => {
    const ids = this.state.list[index].id
    const { data, status, detail } = await onCommodity({ ids: [ids] })
    if (status == 1) {
      Message.success('上架成功')
      this.getPullOffList()
    } else {
      Message.error(detail)
    }
  }

  render() {
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
      },
      {
        title: '商品图片',
        dataIndex: 'photoUrl',
        render: (text, record, index) => {
          return (
            <a href={fixPhotoUrl(text)} target="_blank">
              <img className="product_pic" src={fixPhotoUrl(text)} />
            </a>
          )
        },
      },
      {
        title: '商品名称',
        dataIndex: 'name',
      },
      {
        title: '操作人',
        dataIndex: 'operatorName',
      },
      {
        title: '下架时间',
        dataIndex: 'updateTime',
        render: (text, record, index) => {
          return <div>{toNormalTime(text)}</div>
        },
      },
      {
        title: '操作',
        dataIndex: 'handling',
        render: (text, record, index) => {
          return (
            <Popconfirm
              title="确认要重新上架此商品？"
              onConfirm={() => {
                this.pushUp(index)
              }}
              onCancel={cancel}
              okText="是"
              cancelText="否"
            >
              <a>重新上架</a>
            </Popconfirm>
          )
        },
      },
    ]

    const cancel = () => {}
    return (
      <div>
        <Table
          rowKey="id"
          bordered
          columns={columns}
          dataSource={this.state.list}
          className="mt-20"
        ></Table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/purchaseSalesInventory/components/pullOffShelves.js